import React from "react";
import { makeStyles } from "@material-ui/core";
import { ThemeType } from "@theme";
import locale from "@bonliva-crm/locale";
import { ConsultantQualityCheckDataFragment } from "@bonliva-crm/graphql";
import { QualityCheckMeta } from "./quality-check-meta";
import { formatLabelDate } from "./utils";

type QualityCheckStatusSetOnProps = {
  data: ConsultantQualityCheckDataFragment;
  showComment?: boolean;
};

export function QualityCheckStatusSetOn({
  data,
  showComment
}: QualityCheckStatusSetOnProps) {
  const classes = useStyles();

  if (!data.StatusSetBy || !data.Status) {
    return null;
  }

  const statusComment = data.Status?.Comment;
  const approvedOn = data.StatusSetOn
    ? `${formatLabelDate(data.StatusSetOn)}`
    : `(${locale.DateMissing})`;

  return (
    <>
      <QualityCheckMeta
        title={locale.qualityStatuses[data.Status.Name]}
        description={data.StatusSetBy.Name}
      />

      <QualityCheckMeta title={locale.Date} description={approvedOn} />

      {showComment && statusComment && (
        <QualityCheckMeta
          title={locale.Comment}
          description={
            <div className={classes.sithsCardNumberComment}>{statusComment}</div>
          }
        />
      )}
    </>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  sithsCardNumberComment: {
    display: "flex",
    alignItems: "center"
  },
  sithsCardNumberCopy: {
    marginLeft: 5,
    fontSize: 14,
    color: theme.palette.primary.main
  }
}));
